import { FIREBALL_FRESHDESK, METEORO_FRESHDESK } from './freshdesk.config';

const default_values = {
    "name": "Bison Casino",
    "originalDomain": "bison.casino",
    "logo-xmas": "assets/logo/lemon-logo-xmas-mobile.svg",
    "logo-desktop-xmas": "assets/logo/logo-xmas-desktop.svg",
    "logo": "assets/logo/2023/logo-xmas-mobile.svg",
    "logo-desktop": "assets/logo/2023/logo-xmas-desktop.svg",
    "full-logo": "assets/logo/logo-green.svg",
    "favicon": "assets/icons/logo-favicon.svg",
    "title-substitute": "",
    "search-icon": "assets/desktop/search-in.svg",
    "signup-step-one": "assets/desktop/signup/icon-signup-one.svg",
    "signup-step-two": "assets/desktop/signup/icon-signup-two.svg",
    "signup-step-three": "assets/desktop/signup/icon-signup-three.svg",
    "signup-banner": "assets/desktop/signup/signup-banner.png",
    "tournament-icon": "assets/playbison/icon-tournaments.png",
    "icon-add": "assets/icons/icon-add.svg",
    "sticky-profile": "assets/icons/icon-profile-sticky.svg",
    "sticky-category": "assets/icons/icon-categories-sticky.svg",
    "sticky-live": "assets/icons/icon-live-casino-sticky.svg",
    "sticky-wallet": "assets/icons/icon-wallet-sticky.svg",
    "sticky-search": "assets/icons/icon-search-sticky.svg",
    "btn-close": "assets/desktop/ham-close-btn.svg",
    "btn-cancel": "assets/icons/icon-cancel.svg",
    "btn-error": "assets/icons/icon-error.svg",
    "btn-edit": "assets/icons/icon-edit.svg",
    "btn-edit-full": "assets/icons/icon-edit-full.svg",
    "icon-notification": "assets/icons/icon-notification.svg",
    "icon-operator": "icon-operators.svg",
    "icon-pay-history": "assets/desktop/pay-history.svg",
    "icon-pay-history-png": "assets/fireball/icons/pay-history.png",
    "icon-messages-inbox": "assets/fireball/icons/icon-messages-inbox.png",
    "icon-withdrawal": "assets/icons/icon-withdrawal.svg",
    "icon-edit-profile": "icon-edit-profile.svg",
    "upload-docs-icon": "assets/playbison/icons/upload-not-icon.svg",
    "icon-edit-gear": "assets/playbison/icons/edit-icon.svg",
    "icon-edit-pencil": "assets/playbison/icons/edit-pro-pencil.svg",
    "icon-edit-location": "assets/playbison/icons/edit-location.svg",
    "icon-edit-calender": "assets/playbison/icons/edit-calender.svg",
    "icon-deposit": "assets/icons/icon-deposit.svg",
    "icon-arrow-deposit": "assets/icons/icon-arrow-deposit.svg",
    "icon-arrow-withdrawal": "assets/icons/icon-arrow-withdrawal.svg",
    "icon-right": "assets/desktop/arrow-button.svg",
    "icon-pagination-arrow": "assets/icons/icon-arrow-pagination.svg",
    "icon-arrow": "assets/desktop/yellow-arrow.svg",
    "icon-info": "assets/client-area/icon-info.svg",
    "icon-winnings": "assets/icons/winnings.svg",
    "icon-bets": "assets/icons/bets.svg",
    "icon-time": "assets/icons/time.svg",
    "icon-bonus": "assets/client-area/icon-menu-my-bonuses.svg",
    "icon-promo": "assets/icons/icon-promo-code.svg",
    "icon-how-works": "assets/desktop/tournament/how-it-works.svg",
    "icon-leader": "assets/desktop/tournament/leaderboard.svg",
    "icon-prize": "assets/desktop/tournament/prizes.svg",
    "icon-score": "assets/desktop/tournament/scoring.svg",
    "icon-info-dark": "assets/icons/icon-info.svg",
    "icon-none": "assets/icons/icon-none-round.svg",
    "icon-bonus-wheel": "assets/icons/icon-lemon-lottery-wheel-bonus.png",
    "icon-m-cashback": "assets/mobile/client-area/icon-cashback-mobile-50x50.png",
    "icon-gold-cup": "assets/desktop/tournament/gold-cup.svg",
    "icon-hour-glass": "assets/mobile/hour-glass.svg",
    "icon-tournament": "assets/desktop/tournament/title-icon.svg",
    "icon-box-on": "assets/mobile/client-area/icon-box-mobile-on-50x50.png",
    "icon-player-choice": "assets/icons/icon-players-choice.svg",
    "icon-deposit-game": "assets/icons/icon-deposit-game.svg",
    "icon-game-history": "assets/desktop/game-history-hamburger-icon.svg",
    "icon-edit-no-outline": "assets/icons/icon-edit-no-outline-yellow.svg",
    "icon-menu-btn": "assets/desktop/ham-btn.svg",
    "icon-profile-info": "assets/mobile/client-area/icon-box-mobile-on-50x50.png",
    "icon-support": "assets/desktop/support-page.svg",
    "icon-faq": "assets/desktop/faq-page.svg",
    "icon-responsible-gaming": "assets/fireball/icon-responsible-gaming.svg",
    "icon-self-exclusion": "assets/desktop/self-exclusion-page.svg",
    "icon-client-box-on": "assets/desktop/client-area/icon-box-desktop-on-70x70.png",
    "icon-wheel-on": "assets/desktop/client-area/icon-wheel-desktop-on-120x120.png",
    "icon-treasure-box": "assets/icons/icon-treasure-box-closed.png",
    "icon-teaser-box": "assets/mobile/teaser-bonus-box.svg",
    "icon-email": "assets/desktop/mail-icon.svg",
    "icon-sent-email": "assets/desktop/sent-email.svg",
    "icon-bonus-box": "assets/icons/icon-bonus-box-payment.png",
    "icon-arrow-down": "assets/icons/icon-arrow-down.svg",
    "icon-home": "assets/desktop/home.svg",
    "icon-slots": "assets/desktop/icon-menu-slots.svg",
    "icon-live-casino": "assets/desktop/cards.svg",
    "icon-try-game-close": "assets/icons/close-game-icon.svg",
    "icon-tournament-info": "assets/icons/tournaments/icon-tournament-info.svg",
    "icon-inbox": "assets/icons/icon-inbox-sticky.svg",
    "icon-header-tournament": "icon-tournaments.svg",
    "icon-rule": "assets/desktop/tournament/how-it-works.svg",
    "icon-list": "assets/desktop/tournament/leaderboard.svg",
    "icon-mission": "assets/desktop/tournament/prizes.svg",
    "icon-mission-logo": "assets/icons/icon-missions-main-icon-mobile.svg",
    "icon-exclusive-desktop": "assets/icons/tag-lemon-exclusive-desktop.svg",
    "icon-exclusive-mobile": "assets/icons/icon-exclusive-tag.svg",
    "icon-inbox-empty": "assets/icons/empty-inbox.png",
    "jackpot-avatar": "assets/playbison/icon-avatar.gif",
    "icon-refresh": "assets/icons/icon-refresh.svg",
    "icon-refresh-short": "assets/icons/icon-refresh-short.svg",
    "icon-skeleton": "assets/images/tournament-skeleton.svg",
    "promo-banner": "assets/playbison/icon-promotion-banner.png",
    "success-tick": "assets/playbison/bioson-success-image.png",
    "icon-phone": "assets/playbison/icon-phone.png",
    "icon-delete": "assets/fireball/icons/icon-fb-delete.svg",
    "arrow-icon": "assets/desktop/white-arrow.svg",
    "bonus-excluded": "assets/icons/bonus-excluded.svg",
    "icon-top-slot": "assets/fireball/icons/icon-live-casino.svg",
    "icon-top-aviator": "assets/fireball/icons/icon-aviator.svg",
    "icon-top-chicken-road": "assets/fireball/icons/icon-top-chicken-road.svg",
    "icon-top-live-casino": "assets/fireball/icons/icon-slot.svg",
    "icon-fav": "assets/icons/fav-icon.svg",
    "icon-tag-big-win": "assets/icons/icon-tag-big-win.svg",
    "icon-tag-bonus-excluded": "assets/icons/icon-tag-bonus-excluded.svg",
    "icon-tag-hot": "assets/icons/icon-tag-hot.svg",
    "icon-tag-exclusive": "assets/icons/icon-exclusive-tag.svg",
    "payment-completed": "assets/icons/payment-completed.svg",
    "payment-cancelled": "assets/icons/payment-cancelled.svg",
    "payment-created": "assets/icons/payment-created.svg",
    "info":"assets/icons/info.svg",
    "info-active": "assets/icons/info-active.svg",
    "info-inactive": "assets/icons/info-inactive.svg",
    "shield-with-cherry": "assets/icons/shield-with-cherry.svg",
    "right-circle-arrow": "assets/icons/right-circle-arrow.svg",
    "account-info": "assets/icons/account-info.svg",
    "password-lock": "assets/icons/password-lock.svg",
    "eye-on": "assets/icons/eye-on.svg",
    "eye-off": "assets/icons/eye-off.svg",
    "profile-header": "assets/icons/profile-header.svg",
    "slide-fireball": "assets/icons/slide-fireball.svg",
    "no-data-found": "assets/images/no-data-found.svg",
    "icon-no-data-found": "assets/images/no-data-found.svg"

}

const playbison_defaults = {
    ...default_values,
    "logo": "assets/logo/logo-bison-light.svg",
    "logo-desktop": "assets/logo/logo-bison-light.svg",
    // "logo": "assets/logo/logo-playbison-xmas.svg",
    // "logo-desktop": "assets/logo/logo-playbison-xmas.svg",
    "title-substitute": "Bison Casino",
    "search-icon": "assets/playbison/icon-search-sticky.png",
    "search-icon-page": "assets/playbison/icon_search.png",
    "nothing-found-icon": "assets/playbison/nothing-found-playbison.png",
    "signup-step-one": "assets/playbison/icon-signup-one.png",
    "signup-step-two": "assets/playbison/icon-signup-two.png",
    "signup-step-three": "assets/playbison/icon-signup-three.png",
    "signup-banner": "assets/playbison/signup-banner.png",
    "tournament-icon": "assets/playbison/icon-tournaments.png",
    "icon-add": "assets/playbison/icon-add.png",
    "sticky-profile": "assets/playbison/icon-profile-sticky.png",
    "sticky-category": "assets/playbison/icon-categories-sticky.png",
    "sticky-live": "assets/playbison/icon-live-casino-sticky.png",
    "sticky-wallet": "assets/playbison/icon-wallet-sticky.png",
    "sticky-search": "assets/playbison/icon-search-sticky.png",
    "btn-close": "assets/playbison/icon-close.svg",
    "btn-cancel": "assets/playbison/icon-close.svg",
    "btn-error": "assets/playbison/icon-error.png",
    "btn-edit": "assets/playbison/icon-edit.png",
    "btn-edit-full": "assets/playbison/icon-edit-full.png",
    "icon-notification": "assets/playbison/icon-notification.png",
    "icon-operator": "playbison/icon-operators.png",
    "icon-pay-history": "assets/playbison/icon-payment-history.png",
    "icon-withdrawal": "assets/playbison/icon-withdrawal.png",
    "icon-edit-profile": "playbison/icon-edit-profile.png",
    "icon-edit-profile-page": "playbison/icon-profile-edit.png",
    "icon-profile-page": "playbison/icon-profile.png",
    "icon-deposit": "assets/playbison/icon-deposit.png",
    "icon-right": "assets/playbison/icon-arrow-right.svg",
    "icon-pagination-arrow": "assets/icons/icon-arrow-pagination.svg",
    "icon-info": "assets/playbison/icon-info.png",
    "icon-info-profile": "assets/client-area/icon-info.svg",
    "icon-winnings": "assets/playbison/winnings.png",
    "icon-bets": "assets/playbison/bets.png",
    "icon-time": "assets/playbison/time.png",
    "icon-bonus": "assets/playbison/icon-bonus.png",
    "icon-promo": "assets/playbison/icon-promo-code.png",
    "icon-how-works": "assets/playbison/icon-rule.png",
    "icon-leader": "assets/playbison/icon-tournaments-leaderboard.png",
    "icon-prize": "assets/playbison/icon-tournaments-prizes.png",
    "icon-score": "assets/playbison/icon-tournaments-points.png",
    "icon-info-dark": "assets/playbison/icon-info.png",
    "icon-none": "assets/playbison/icon-none-round.png",
    "icon-bonus-wheel": "assets/playbison/icon-lemon-lottery-wheel-bonus.png",
    // "icon-m-wheel-off":"assets/playbison/icon-wheel-off-mobile-84x84.png",
    // "icon-m-wheel-on" : "assets/playbison/icon-wheel-on-mobile-84x84.png",
    "icon-m-cashback": "assets/playbison/icon-cashback-mobile-50x50.png",
    "icon-gold-cup": "assets/playbison/trophy.png",
    "icon-gold-cup-1": "assets/playbison/trophy-1.png",
    "icon-gold-cup-2": "assets/playbison/trophy-2.png",
    "icon-gold-cup-3": "assets/playbison/trophy-3.png",
    "icon-hour-glass": "assets/playbison/hour-glass.png",
    "icon-tournament": "assets/playbison/icon-tournaments.png",
    "icon-box-on": "assets/playbison/icon-scratch-cards-profile-55x55.png",
    // "icon-box-off" : "assets/playbison/icon-box-mobile-off-50x50.png",
    "icon-player-choice": "assets/playbison/icon-players-choice.png",
    "icon-deposit-game": "assets/playbison/icon-deposit-game.svg",
    "icon-game-history": "assets/playbison/icon-game-history.png",
    "icon-edit-no-outline": "assets/playbison/icon-edit-no-outline-yellow.png",
    "icon-menu-btn": "assets/playbison/menu-btn.png",
    "icon-profile-info": "assets/playbison/icon-scratch-cards-profile-55x55.png",
    "icon-support": "assets/playbison/icon-support.png",
    "icon-faq": "assets/playbison/icon-faq.png",
    "icon-responsible-gaming": "assets/fireball/icon-responsible-gaming.svg",
    "icon-self-exclusion": "assets/playbison/icon-self-exclusion.png",
    "icon-client-box-on": "assets/playbison/icon-scratch-cards-profile-55x55.png",
    "icon-wheel-on": "assets/playbison/icon-spin-and-win-120x120.png",
    "icon-treasure-box": "assets/playbison/icon-scratch-cards-profile-55x55.png",
    "icon-teaser-box": "assets/playbison/icon-spin-and-win-120x120.png",
    "icon-email": "assets/playbison/mail-icon.svg",
    "icon-sent-email": "assets/playbison/sent-email.svg",
    "icon-bonus-box": "assets/playbison/icon-bonus-box.svg",
    "icon-arrow-down": "assets/playbison/icon-arrow-down.png",
    "compaign-switch": "assets/playbison/icon_reactivation_switch2.svg",
    "compaign-info-icon": "assets/playbison/icon-info.png",
    "campign-btn-down": "assets/playbison/btn-down-arrow.svg",
    "campaign-btn-mobile": "assets/playbison/btn-campaign-arrow.png",
    "icon-home": "assets/playbison/icon-home.png",
    "icon-slots": "assets/playbison/icon-slots.png",
    "icon-live-casino": "assets/playbison/icon-live-casino.png",
    "icon-try-game-close": "assets/playbison/icon-try-game-close.svg",
    "icon-tournament-info": "assets/playbison/icon-tournament-info.svg",
    "icon-inbox": "assets/playbison/icon-messages-inbox.png",
    "icon-header-tournament": "icon-tournaments.png",
    "icon-rule": "assets/playbison/icon-mission-info.svg",
    "icon-list": "assets/playbison/icon-mission-games.svg",
    "icon-mission": "assets/playbison/icon-mission.svg",
    "icon-mission-home": "assets/playbison/icon-missions-home.svg",
    "batch-icon-mission": "assets/playbison/icon_mission_active.svg",
    "batch-icon-schedule": "assets/playbison/icon_mission_schedule.svg",
    "icon-mission-logo": "assets/playbison/icons/icon-missions-main-icon-mobile.svg",
    "icon-exclusive-desktop": "assets/playbison/tag-playbison-exclusive.svg",
    "icon-exclusive-mobile": "assets/playbison/tag-playbison-exclusive.svg",
    "icon-inbox-empty": "assets/playbison/icon-inbox-empty.png",
    "inbox-empty": "assets/playbison/empty-inbox.svg",
    "icon-refresh": "assets/playbison/icons/icon-refresh.svg",
    "icon-refresh-short": "assets/playbison/icons/icon-refresh-short.svg",
    "icon-skeleton": "assets/playbison/icon-skeleton.svg",
    "badge-hot-mobile": "assets/playbison/icons/badge-bisoncasino-hot-mobile.svg",
    "badge-hot-desktop": "assets/playbison/icons/badge-bisoncasino-hot-desktop.svg",
    "badge-bigwin-mobile": "assets/playbison/icons/badge-bisoncasino-bigwin-mobile.svg",
    "badge-bigwin-desktop": "assets/playbison/icons/badge-bisoncasino-bigwin-desktop.svg",
    "login-welcomeback": "assets/playbison/login/welcome-back-login-img.svg",
    "login-wrongpassword": "assets/playbison/login/wrongpassword-img.svg",
    "lost-password": "assets/playbison/login/lost-password-img.svg",
    "newpassword": "assets/playbison/login/newpassword-img.svg",
    "login-success": "assets/playbison/login/login-success-img.svg",
    "login-email-icon": "assets/playbison/login/icon-messages.svg",
    "eye-close-icon": "assets/playbison/login/icon-eyedisabled.svg",
    "eye-open-icon": "assets/playbison/login/icon-eye.svg",
    "login-error-icon": "assets/playbison/login/login-warning-icon.svg",
    "mission-completed": "assets/playbison/icons/icon-mission-completed.svg",
    "my-games-icon": "assets/icons/categories/icon-my-games.png",
    "icon-exclamation": "assets/icons/icon-exclamation.svg",
    "change-password-img": "assets/playbison/login/change-pass-banner.svg",
    "icon-menu-change-password": "assets/playbison/login/icon-menu-change password.svg",
    "icon-vip-leef": "assets/playbison/bison-vip-leaves.svg",
    "icon-my-game": "assets/playbison/icons/icon-my-game-72x72.svg",
    "icon-wallet-bonus-black": "assets/playbison/icons/wallet-bonus-icon.svg",
    "icon-bonus-drop": "assets/playbison/icons/bonus-drop.svg",
    "game-history-icon": "assets/playbison/icon-game-history.svg",
    "pending-withdrawal": "assets/fireball/icons/icon-fb-pending-withdrawal.png",
    "reactivation-empty-card": "assets/playbison/icon_reactivation_empty.png",
    "icon-deposit-compaign-info": "assets/playbison/icon-deposit-compaign-info.svg",
    "icon-xmas-decor": "assets/playbison/icons/icon-xmas-decor.svg",
    "icon-bison-xmas-nextday": "assets/playbison/icon-bisoncasino-christmas-nextday-mobile.png",
    "icon-xmas-notification": "assets/playbison/xmas/icon-xmas-teaser-off.png",
}

const fireball_defaults = {
    ...playbison_defaults,
    "name": "Fireball casino",
    "originalDomain": "fireball.casino",
    "title-substitute": "Fireball Casino",
    "logo": "assets/fireball/logo-fireball.svg",
    "logo-desktop": "assets/fireball/logo-fireball-desktop.svg",
    "sticky-category": "assets/fireball/icons/categories.svg",
    "sticky-live": "assets/fireball/icons/live-casino.svg",
    "sticky-wallet": "assets/fireball/icons/wallet.svg",
    "sticky-icon-wallet": "assets/fireball/icons/icon-wallet.svg",
    "sticky-bonus": "assets/fireball/icons/bonus-box.svg",
    "sticky-search": "assets/fireball/icons/search.svg",
    "sticky-profile": "assets/fireball/icons/icon-profile.svg",
    "category-icon": "assets/icons/icon_categories.svg",
    "search-icon-page": "assets/fireball/icons/search.svg",
    "search-home-page": "assets/fireball/icons/icon-fb-search.svg",
    "icon-menu-btn": "assets/fireball/icons/menu.svg",
    "icon-logout": "assets/fireball/icons/logout.svg",
    "game-placeholder": "assets/fireball/icons/game-placeholder.svg",
    "icon-email": "assets/fireball/icons/mail.svg",
    "icon-avatar": "assets/fireball/icons/avatar.svg",
    "icon-edit-avater": "assets/fireball/icons/icon-edit-avatar.svg",
    "icon-tournament": "assets/fireball/tournament/icon-tournaments.svg",
    "icon-game-history": "assets/fireball/icons/icon-game-history.png",
    "icon-skeleton": "assets/fireball/icons/icon-skeleton.svg",
    "icon-rule": "assets/fireball/icons/icon-mission-info.png",
    "icon-how-works": "assets/fireball/icons/icon-mission-info.png",
    "icon-prize": "assets/fireball/icons/icon-tournaments-prizes.png",
    "icon-score": "assets/fireball/icons/icon-tournaments-points.png",
    "icon-list": "assets/fireball/missions/icon-mission-games.svg",
    "icon-wheel-on": "assets/fireball/icons/icon-spin-and-win-120x120.png",
    "icon-teaser-box": "assets/fireball/icons/icon-spin-and-win-120x120.png",
    "icon-bonus": "assets/fireball/icons/icon-bonus.png",
    "icon-edit-profile-page": "assets/fireball/icons/icon-profile-edit.png",
    "icon-leader": "assets/fireball/icons/icon-tournaments-leaderboard.png",
    "icon-box-on": "assets/fireball/icons/icon-scratch-cards-profile-55x55.png",
    "icon-profile-info": "assets/fireball/icons/icon-scratch-cards-profile-55x55.png",
    "icon-profile-scratch": "assets/fireball/icons/avatar.png",
    "icon-client-box-on": "assets/fireball/icons/icon-scratch-cards-profile-55x55.png",
    "icon-treasure-box": "assets/fireball/icons/icon-scratch-cards-profile-55x55.png",
    "icon-support": "assets/fireball/icons/icon-support.svg",
    "icon-faq": "assets/fireball/icons/icon-faq.svg",
    "icon-self-exclusion": "assets/fireball/icons/icon-self-exclusion.svg",
    "icon-info-profile": "assets/fireball/icons/icon-info.svg",
    "icon-operator": "icon-ops.svg",
    "icon-ingame-tour": "assets/fireball/icons/icon-tournaments-main-icon-mobile.svg",
    "icon-info": "assets/fireball/icons/icon-info.svg",
    "icon-live-casino": "assets/fireball/icons/live-casino.svg",
    "icon-slots": "assets/fireball/icons/icon-slots.svg",
    "icon-home": "assets/fireball/icons/icon-home.svg",
    "icon-loged-in": "assets/fireball/icons/ball-icon.png",
    "icon-deposit": "assets/fireball/icons/icon-deposit.svg",
    "icon-deposit-title": "assets/fireball/icons/payment-icon-title.svg",
    "icon-withdrawal": "assets/fireball/icons/icon-withdrawal.svg",
    "icon-withdrawal-title": "assets/fireball/icons/payment-icon-title.svg",
    "icon-bonus-box": "assets/fireball/icons/fireball-bonus-box.svg",
    "badge-hot-mobile": "assets/fireball/icons/badge-fireball-hot-mobile.svg",
    "badge-hot-desktop": "assets/fireball/icons/badge-fireball-hot-desktop.svg",
    "badge-bigwin-mobile": "assets/fireball/icons/badge-fireball-bigwin-mobile.svg",
    "badge-bigwin-desktop": "assets/fireball/icons/badge-fireball-bigwin-desktop.svg",
    "icon-m-cashback": "assets/fireball/icons/icon-fb-cashback1a.svg",
    "icon-cashback-history": "assets/fireball/icons/icon-cashback-history.svg",
    "icon-register": "assets/fireball/icons/icon-registration.png",
    "icon-spin-active": "assets/fireball/icons/icon-fb-spin.png",
    "icon-category-crash": "assets/fireball/icons/icon-category-crash.svg",
    "icon-tag": "assets/fireball/icons/icon-promo-tag.svg",
    "lock-icon": "assets/fireball/dialog-box/img-fireball-padlock 1.svg",
    "icon-white-downarrow": "assets/fireball/icons/icon-down-arrow-white.svg",
    "icon-nav-arrow-white": "assets/fireball/icons/icon-fb-nav-arrow-white.svg",
    "icon-my-games": "assets/fireball/icons/icon-my-games.png",
    "icon-fire": "assets/fireball/icons/icon-fire.svg",
    "icon-crash-game": "assets/fireball/icons/icon-crash-game-img.svg",
    "mission-completed": "assets/fireball/icons/icon-mission-completed.svg",
    "icon-mission-home": "assets/fireball/icons/icon-mission-home.svg",
    "icon-success-popup": "assets/fireball/dialog-box/success-popup-img.png",
    "icon-payment-success-popup": "assets/fireball/dialog-box/payment-success-popup-img.png",
    "icon-404": "assets/fireball/fireball-404-image.png",
    "icon-tournament-all-game": "assets/fireball/tournament/icon-tournaments.svg",
    "icon-tournament-fineshed-game": "assets/fireball/tournament/icon-tournaments-finished.png",
    "icon-mission-all-game": "assets/fireball/missions/icon-mission-all.svg",
    "icon-upcoming-game": "assets/fireball/tournament/icon-tournaments-scheduled.png",
    "icon-live-game": "assets/fireball/tournament/icon-tournaments-live.png",
    "icon-maintanence": "assets/fireball/icons/img-fb-maintenance.png",
    "icon-signup-one": "assets/fireball/icons/image-signup-dialogue.png",
    "icon-rank-1": "assets/fireball/icons/icon-rank-1.svg",
    "icon-rank-2": "assets/fireball/icons/icon-rank-2.svg",
    "icon-rank-3": "assets/fireball/icons/icon-rank-3.svg",
    "icon-copy": "assets/desktop/lucide_copy.svg",
    "icon-money-bag": "assets/desktop/moneybag.svg",
    "icon-friends": "assets/desktop/icon-lemon-friends.svg",
    "icon-avatar-friend": "assets/desktop/feel-the-heat-campaign-icon-ON.png",
    "icon-mission-completed-disabled": "assets/fireball/missions/icon-mission-completed-disabled.svg",
    "icon-reward-money-bag": "assets/desktop/img-lemon-money-bag.png",
    "icon-tick-mark": "assets/desktop/icon-tick-mark.png",
    "arrow-round-icon": "assets/desktop/button-arrow.png",
    "icon-mission-tick": "assets/fireball/missions/mission-tick-icon.svg",
    "icon-exclamation": "assets/fireball/icons/icon-warrning.svg",
    "upload-docs-icon": "assets/fireball/icons/icon-pending-withdrawal.png",
    "inbox-empty": "assets/fireball/empty-inbox.png",
    "icon-pen-edit": "assets/fireball/icons/icon-pen-edit.svg",
    "icon-calendar-edit": "assets/fireball/icons/icon-calendar-edit.svg",
    "icon-map-edit": "assets/fireball/icons/icon-edit-map.svg",
    "icon-profile-scratch-cards": "assets/fireball/icons/icon-scratch-cards-profile.svg",
    "icon-prize-box-card": "assets/fireball/icons/icon-scratch-cards-profile.svg",
    "icon-bonus-money": "assets/fireball/icons/icon-bonus-money.svg",
    "icon-fireball-vip-leef": "assets/fireball/icons/fireball-vip-leaves.svg",
    "icon-fb-promo-code": "assets/fireball/icons/icon-fb-promo-code.png",
    "icon-wallet-bonus-black": "assets/fireball/icons/icon-bonus-black.svg",
    "default-profile": "assets/desktop/fb-profile-generic.png",
    "success-tick-signup": "assets/fireball/icons/success-tick-signup.png",
    "icon-right": "assets/fireball/icons/icon-white-arrow.svg",
    "icon-pagination-arrow": "assets/fireball/icons/icon-arrow-pagination.svg",
    "icon-info-none": "assets/fireball/icons/icon-info-none.svg",
    "icon-info-dark": "assets/fireball/icons/icon-info-dark.svg",
    "icon-info-white": "assets/fireball/icons/icon-info-white.svg",
    "icon-fb-my-games": "assets/fireball/icons/icon-fb-my-games.svg",
    "icon-fb-refresh": "assets/fireball/icons/icon-fb-refresh.svg",
    "icon-info-orange": "assets/fireball/icons/icon-info-orange.svg",
    "icon-fb-ok-status": "assets/fireball/icons/icon-fb-ok-status.svg",
    "icon-fb-pen-status": "assets/fireball/icons/icon-fb-pen-status.svg",
    "icon-fb-bad-status": "assets/fireball/icons/icon-fb-bad-status.svg",
    "icon-recommended": "assets/fireball/icons/fb-category-icon-recommended.svg",
    "icon-bonus-drop": "assets/fireball/icons/icon-bonus.png",
    "icon-bonus-drop-new": "assets/fireball/icons/icon-bonus-drop.svg",
    "icon-bonus-drop-success": "assets/fireball/icons/success-pending-reward.svg",
    "full-screen": "assets/fireball/icons/full-screen.svg",
    "fireballs": "assets/fireball/icons/fireballs.png",
    "card-info": "assets/fireball/icons/icon-warning.png",
    "less-regular": "assets/fireball/icons/Vs.png",
    "icon-warn": "assets/fireball/icons/icon-warn.png",
    "level-1": "assets/fireball/levels/level-1.png",
    "level-2": "assets/fireball/levels/level-2.png",
    "level-3": "assets/fireball/levels/icon-level-3.png",
    "level-4": "assets/fireball/levels/icon-level-4.png",
    "level-5": "assets/fireball/levels/icon-level-5.png",
    "level-6": "assets/fireball/levels/icon-level-6.png",
    "uploade-document-img": "assets/fireball/uploade-document-img.png",
    "uploade-icon": "assets/fireball/icons/upload.png",
    "verification-icon": "assets/fireball/icons/verification.png",
    "verified-icon": "assets/fireball/icons/verified.png",
    "unverified-icon": "assets/fireball/icons/unverified.png",
    "button-close": "assets/fireball/icons/button-close.svg",
    "spino_drops": "assets/fireball/icons/spino_drops.png",
    "active_tick": "assets/fireball/icons/checkmark.svg",
    "info-icon": "assets/fireball/icons/info-icon.svg",
    "icon-dropdown-chevron": "assets/fireball/icons/icon-dropdown.svg",
    "icon-mission-task": "assets/fireball/missions/icon-mission-task.svg",
    "icon-info-new": "assets/fireball/missions/icon-info-new.svg",
    "icon-fb-spin-inactive":"assets/fireball/icons/icon-fb-spin-inactive.svg",
    "icon-new-info": "assets/fireball/icons/icon-new-info.svg",
    "icon-spin-off": "assets/fireball/icons/icon-spin-off.svg",
    "btn-turn-off": "assets/fireball/icons/btn-turn-off.svg",
    "btn-arrow-left": "assets/fireball/icons/fb-btn-arrow.svg",
    "game-info-search": "assets/fireball/icons/game-info-search.svg",
    "ingame-tournament": "assets/fireball/icons/fb-ingame-tournament-icon.svg",
    "ingame-mission": "assets/fireball/icons/fb-ingame-mission.svg",
    "game-favourites-off": "assets/fireball/icons/game-favourites-off.svg",
    "game-favourites-on": "assets/fireball/icons/game-favourites-on.svg",
    "game-info-resize":"assets/fireball/icons/game-info-resize.svg",
    "game-info-close":"assets/fireball/icons/game-info-close.svg",
    "bonus-offer-img":"assets/fireball/bonus-ing.png",
    "icon-info-gradient":"assets/fireball/icons/button-info.svg",
    "icon-bonus-box-new":"assets/fireball/icons/bonus-box-icon.svg",
    "icon-img-bonus-box":"assets/fireball/icon-img-bonus-box.svg",
    "add-bonus-img":"assets/fireball/add-bonus-img.svg",
    "icon-info-minus":"assets/fireball/icons/icon-info-minus.svg",
    "teasure-banner-img":"assets/fireball/teasure-banner-img.svg",
    "teasure-banner-img-mobile":"assets/fireball/teasure-banner-img-mobile.png",
    "add-gradient-bg": "assets/fireball/add-gradient-bg.svg",
    "swap-gradient-bg": "assets/fireball/swap-gradient-bg.svg",
    "fireball-lottery-wheel-static": "assets/gamification/wheel/fire-ball/fireball-lottery-wheel-static.png",
    "fireball-lottery-wheel-rotate":"assets/gamification/wheel/fire-ball/fireball-lottery-wheel-rotate.png",
    "lottery-info":"assets/gamification/wheel/fire-ball/info.svg",
    "wheel-logo":"assets/gamification/wheel/fire-ball/wheel-logo.png",
    "icon-payment-info":"assets/icons/icon-payment-info.svg",
    "deposit-add-icon":"assets/fireball/icons/deposit-add-icon.png",
    "icon-change-password":"assets/fireball/icons/icon-change-password.svg",
    "img-change-password":"assets/fireball/icons/img-change-password.png",
    "icon-eye-on":"assets/fireball/icons/eye-on.svg",
    "icon-warning-info":"assets/icons/warning_hint_icon.svg",
    "icon-edit-profile":"assets/fireball/icons/icon-edit-profile.svg",
    "icon-info-gray":"assets/icons/icon-info-gray.svg",
    "icon-new-my-bonuses":"assets/fireball/icons/icon-new-my-bonuses.svg",
    "icon-new-edit-profile":"assets/fireball/icons/icon-new-edit-profile.svg",
    "icon-new-my-games":"assets/fireball/icons/icon-new-my-games.svg",
    "icon-exclusive-mobile": "assets/icons/icon-exclusive-tag.svg",
    "icon-new-categories":"assets/fireball/icon-new-categories.svg",
    "icon-new-wallet":"assets/fireball/icon-new-wallet.svg",
    "icon-eye-off": "assets/fireball/icons/eye-off.svg",
    "icon-fb-arrow-down": "assets/fireball/icon-arrow-down.png",
    "icon-my-bonuses": "assets/fireball/icons/icon-my-bonuses.png",
    "icon-profile-header": "assets/fireball/icons/icon-profile-header.svg",
    "icon-level-prefix": "assets/fireball/levels/icon-level-",
    "icon-prizebox": "assets/fireball/icons/icon-prizebox.png",
    "icon-prizebox-group": "assets/fireball/icons/icon-prizebox-group.png",
    "icon-scratch-card-background": "assets/fireball/icons/scrath-card-background.png",
    "icon-pay-history": "assets/desktop/pay-history.svg",
    "icon-pay-history-png": "assets/fireball/icons/pay-history.png",
    "icon-promotions": "assets/fireball/icons/icon-promotions.png",
    "icon-btn-arrow": "assets/fireball/btn-arrow.svg",
    "img-scratch-ball-on": "assets/fireball/icons/img-scratch-ball-on.png",
    "icon-down-btn-notification": "assets/fireball/down-btn-notification.svg",
    "icon-explosion-gradient-high": "assets/fireball/icons/explosion-gradient-high.svg",
    "icon-explosion-gradient-low": "assets/fireball/icons/explosion-gradient-low.svg",
    "icon-teaser-promo-icon": "assets/fireball/icons/teaser-promo-icon.png",
    "icon-boosted-bonus-received-spins": "assets/fireball/icons/boosted-bonus-received-spins.png",
    "icon-boosted-bonus": "assets/fireball/icons/boosted-bonus.png",
    "icon-fav-remove-40x40": "assets/fireball/icons/icon_fav_remove_40x40.svg",
    "icon-fav-add-40x40": "assets/fireball/icons/icon_fav_add_40x40.svg",
    "icon-info-png": "assets/fireball/icons/icon-info.png",
    "icon-jackpot-placeholder": "assets/fireball/icons/jackpot-placeholder.jpg",
    "icon-jackpot": "assets/fireball/icons/icon-jackpot.svg",
    "jackpot-banner-desktop": "assets/fireball/jackpot-banner.png",
    "jackpot-banner-mobile": "assets/fireball/mobile-jackpot-banner.png",
    "icon-jackpot-tier-desktop-prefix": "assets/fireball/icons/jackpot/icon-desktop-tier-",
    "icon-jackpot-tier-mobile-prefix": "assets/fireball/icons/jackpot/icon-mobile-tier-",
    "icon-fb-category-icon2": "assets/fireball/icons/fb-category-icon2.svg",
    "icon-global-notification": "assets/fireball/india-lp/global-notification/notification.png",
    "icon-close-notification": "assets/fireball/icons/icon-close-notification.svg",
    "icon-upi-apps": "assets/fireball/icons/upi-apps.svg",
    "icon-doc-upload": "assets/fireball/icons/icon-doc-upload.svg",
    "icon-menu-promotions": "assets/fireball/icons/icon-menu-promotions.svg",
    "icon-messages-inbox": "assets/fireball/icons/icon-messages-inbox.png",
    "vip-avatar-spark": "assets/fireball/icons/vip-avatar/vip-spark.svg",
    "vip-badge-spark": "assets/fireball/icons/vip-avatar/vip-spark-badge.png",
    "vip-avatar-flame": "assets/fireball/icons/vip-avatar/vip-flame.svg",
    "vip-badge-flame": "assets/fireball/icons/vip-avatar/vip-flame-badge.png",
    "vip-avatar-blaze": "assets/fireball/icons/vip-avatar/vip-blaze.svg",
    "vip-badge-blaze": "assets/fireball/icons/vip-avatar/vip-blaze-badge.png",
    "india-lp-icons-close": "assets/fireball/india-lp/images/icons-close.svg",
    "india-lp-upi": "assets/fireball/india-lp/images/upi.svg",
    "india-lp-imps": "assets/fireball/india-lp/images/imps-logosdada.svg",
    "india-lp-jeton": "assets/fireball/india-lp/images/jeton-logo.svg",
    "india-lp-astropay": "assets/fireball/india-lp/images/astropay.svg",
    "india-lp-bitcoin": "assets/fireball/india-lp/images/bitcoin-logo.svg",
    "india-lp-andar-bahar-desktop": "assets/fireball/india-lp/images/PlayBison-LP-India-andar_bahar_thumbnail_desktop.png",
    "india-lp-andar-bahar-mobile": "assets/fireball/india-lp/images/PlayBison-LP-India-andar_bahar_thumbnail.png",
    "india-lp-teen-pati-desktop": "assets/fireball/india-lp/images/PlayBison-LP-India-teen_pati_thumbnail_desktop.png",
    "india-lp-jackpot-mobile": "assets/fireball/india-lp/images/bison_jackpot_394x256-notext-mobile.png",
    "india-lp-slider-1": "assets/fireball/india-lp/slider-images/slider-image-1.svg",
    "india-lp-slider-2": "assets/fireball/india-lp/slider-images/slider-image-2.svg",
    "india-lp-slider-3": "assets/fireball/india-lp/slider-images/slider-image-3.svg",
    "india-lp-slider-4": "assets/fireball/india-lp/slider-images/slider-image-4.svg",
    "india-lp-casino-experience-bg-desktop": "assets/fireball/india-lp/images/PlayBison-LP-India-AmazingCasinoExperience-BGv2.png",
    "india-lp-casino-experience-bg-mobile": "assets/fireball/india-lp/images/PlayBison-LP-India-AmazingCasinoExperience-BGv2.svg",
    "india-lp-winnings-slider": "assets/fireball/india-lp/slider-images/winnings-slider.svg",
    "india-lp-jackpot-notext": "assets/fireball/india-lp/images/bison_jackpot_394x256-notext.svg",
    "india-lp-jackpot-notext-1": "assets/fireball/india-lp/images/bison_jackpot_394x256-notext-1.svg",
    "india-lp-jackpot-notext-3": "assets/fireball/india-lp/images/bison_jackpot_394x256-notext-3.png",
    "india-lp-devices-desktop": "assets/fireball/india-lp/images/Fireball-LP-India-devices.png",
    "india-lp-devices-mobile": "assets/fireball/india-lp/images/Fireball-LP-India-devices-mobile.svg",
    "india-lp-spribe": "assets/fireball/india-lp/images/spribe.svg",
    "india-lp-microgaming": "assets/fireball/india-lp/images/microgaming.svg",
    "india-lp-netent": "assets/fireball/india-lp/images/netent.svg",
    "india-lp-play-n-go": "assets/fireball/india-lp/images/play-n-go.svg",
    "india-lp-pp": "assets/fireball/india-lp/images/pp.svg",
    "india-lp-red-tiger": "assets/fireball/india-lp/images/red-tiger.svg",
    "india-lp-upi-logo-vector": "assets/fireball/india-lp/images/1200px-UPI-Logo-vector 1.svg",
    "india-lp-logo": "assets/fireball/india-lp/logo/logo.svg",
    "india-lp-banner": "assets/fireball/india-lp/slider-images/banner.jpg",
    "india-lp-fire-ball-bg": "assets/fireball/india-lp/images/fire-ball-bg.jpg",
    "icon-boosted-bonus-box-on": "assets/fireball/icons/icon-boosted-bonus-box-ON.png",
    "icon-boosted-bonus-box-off": "assets/fireball/icons/icon-boosted-bonus-box-OFF.png",
    "icon-boosted-bonus-box-off-fireball": "assets/fireball/icon-boosted-bonus-box-OFF-fireball.png",
    "img-fireball-bonus-box": "assets/fireball/icons/img-fireball-bonus-box.svg",
    "icon-explosion-gradient": "assets/fireball/explosion-gradient.png",
    "icon-accordion-arrow-down": "assets/fireball/india-lp/images/arrow-down.svg",
    "icon-accordion-arrow-up": "assets/fireball/india-lp/images/up-arrow.svg",
    "img-scratch-ball-off": "assets/fireball/icons/img-scratch-ball-OFF.png",
    "bg-image-terms": "assets/fireball/desktop-bg.jpg",
    "header-banner-vip": "assets/fireball/vip-page/banner-desk.png",
    "india-lp-vector-group": "assets/fireball/india-lp/images/Vector-group.svg",
    "india-lp-arrow-left": "assets/fireball/india-lp/images/PlayBison-arrow-left.png",
    "india-lp-arrow-right": "assets/fireball/india-lp/images/PlayBison-arrow-right.png",
    "random-game": "assets/fireball/icons/random-game.png",
    "random-game-thumbnail": "assets/fireball/icons/random-game-thumbnail.png",
    "game-card-placeholder-fireball": "assets/fireball/icons/game-card-placeholder-fireball.svg",
    "pw-icon-title-desktop": "assets/fireball/pending-withdrawal/icon-pending-withdrawals-48.svg",
    "pw-icon-title-mobile": "assets/fireball/pending-withdrawal/icon-pending-withdrawals-32.svg",
    "pw-icon-info": "assets/fireball/pending-withdrawal/icon-info.svg",
    "pw-icon-arrow-active": "assets/fireball/pending-withdrawal/icon-arrow-active.svg",
    "pw-icon-arrow-disabled": "assets/fireball/pending-withdrawal/icon-arrow-disabled.svg",
    "pw-icon-arrow-small": "assets/fireball/pending-withdrawal/icon-arrow-small.svg",
    "pw-icon-count-badge": "assets/fireball/pending-withdrawal/icon-count-badge.svg",
}

export const LICENCE_CONFIG_MAP = {
    "default": default_values,
    "orange_curacao": {
        "logo": "assets/logo/orange-logo.svg",
        "logo-desktop": "assets/logo/orange-logo.svg",
        "full-logo": "assets/logo/orange-logo.svg",
        "title-substitute": "Orange Casino",

    },
    "playbison": {
        ...playbison_defaults
    },
    "playbison_club": {
        ...playbison_defaults
    },
    "playbull_vip": {
        ...default_values,
        "name": "Playbull VIP",
        "originalDomain": "playbull.vip",
        "logo": "assets/bisonwin/logo-color.png",
        "logo-desktop": "assets/bisonwin/logo-color.png",
        "title-substitute": "Bison Casino",
        "search-icon": "assets/playbison/icon-search-sticky.png",
        "signup-step-one": "assets/playbison/icon-signup-one.png",
        "signup-step-two": "assets/playbison/icon-signup-two.png",
        "signup-step-three": "assets/playbison/icon-signup-three.png",
        "signup-banner": "assets/playbison/signup-banner.png",
        "tournament-icon": "assets/playbison/icon-tournaments.png",
        "icon-add": "assets/playbison/icon-add.png",
        "sticky-profile": "assets/playbison/icon-profile-sticky.png",
        "sticky-category": "assets/playbison/icon-categories-sticky.png",
        "sticky-live": "assets/playbison/icon-live-casino-sticky.png",
        "sticky-wallet": "assets/playbison/icon-wallet-sticky.png",
        "sticky-search": "assets/playbison/icon-search-sticky.png",
        "btn-close": "assets/playbison/icon-close.svg",
        "btn-cancel": "assets/playbison/icon-close.svg",
        "btn-error": "assets/playbison/icon-error.png",
        "btn-edit": "assets/playbison/icon-edit.png",
        "btn-edit-full": "assets/playbison/icon-edit-full.png",
        "icon-notification": "assets/playbison/icon-notification.png",
        "icon-operator": "playbison/icon-operators.png",
        "icon-pay-history": "assets/playbison/pay-history.png",
        "icon-withdrawal": "assets/playbison/icon-withdrawal.png",
        "icon-edit-profile": "playbison/icon-edit-profile.png",
        "icon-deposit": "assets/playbison/icon-deposit.png",
        "icon-right": "assets/playbison/icon-arrow-right.svg",
        "icon-info": "assets/playbison/icon-info.png",
        "icon-winnings": "assets/playbison/winnings.png",
        "icon-bets": "assets/playbison/bets.png",
        "icon-time": "assets/playbison/time.png",
        "icon-bonus": "assets/playbison/icon-bonus.png",
        "icon-promo": "assets/playbison/icon-promo-code.png",
        "icon-how-works": "assets/playbison/icon-rule.svg",
        "icon-leader": "assets/playbison/icon-tournaments-leaderboard.svg",
        "icon-prize": "assets/playbison/icon-tournaments-prizes.svg",
        "icon-score": "assets/playbison/icon-tournaments-points.svg",
        "icon-info-dark": "assets/playbison/icon-info.png",
        "icon-none": "assets/playbison/icon-none-round.png",
        "icon-bonus-wheel": "assets/playbison/icon-lemon-lottery-wheel-bonus.png",
        // "icon-m-wheel-off":"assets/playbison/icon-wheel-off-mobile-84x84.png",
        // "icon-m-wheel-on" : "assets/playbison/icon-wheel-on-mobile-84x84.png",
        "icon-m-cashback": "assets/playbison/icon-cashback-mobile-50x50.png",
        "icon-gold-cup": "assets/playbison/trophy.png",
        "icon-hour-glass": "assets/playbison/hour-glass.png",
        "icon-tournament": "assets/playbison/icon-tournaments.png",
        "icon-box-on": "assets/playbison/icon-scratch-cards-profile-55x55.png",
        // "icon-box-off" : "assets/playbison/icon-box-mobile-off-50x50.png",
        "icon-player-choice": "assets/playbison/icon-players-choice.png",
        "icon-deposit-game": "assets/playbison/icon-deposit-game.svg",
        "icon-game-history": "assets/playbison/game-history.png",
        "icon-edit-no-outline": "assets/playbison/icon-edit-no-outline-yellow.png",
        "icon-menu-btn": "assets/playbison/menu-btn.png",
        "icon-profile-info": "assets/playbison/icon-scratch-cards-profile-55x55.png",
        "icon-support": "assets/playbison/icon-support.png",
        "icon-faq": "assets/playbison/icon-faq.png",
        "icon-self-exclusion": "assets/playbison/icon-self-exclusion.png",
        "icon-client-box-on": "assets/playbison/icon-scratch-cards-profile-55x55.png",
        "icon-wheel-on": "assets/playbison/icon-bonus-120x120.png",
        "icon-treasure-box": "assets/playbison/icon-scratch-cards-profile-55x55.png",
        "icon-teaser-box": "assets/playbison/icon-bonus-120x120.png",
        "icon-email": "assets/playbison/mail-icon.svg",
        "icon-sent-email": "assets/playbison/sent-email.svg",
        "icon-bonus-box": "assets/playbison/icon-bonus-box.svg",
        "icon-arrow-down": "assets/playbison/icon-arrow-down.png",
        "icon-home": "assets/playbison/icon-home.svg",
        "icon-slots": "assets/playbison/icon-slots.png",
        "icon-live-casino": "assets/playbison/icon-live-casino.png",
        "icon-inbox": "assets/playbison/icon-messages-inbox.png",
        "icon-header-tournament": "icon-tournaments.png",
        "icon-rule": "assets/playbison/icon-rule.svg",
        "icon-list": "assets/playbison/icon-list.svg",
        "icon-mission": "assets/playbison/icon-mission.svg",
        "icon-mission-logo": "assets/playbison/icon-mission-logo.png",
        "icon-exclusive-desktop": "assets/playbison/tag-playbison-exclusive.svg",
        "icon-exclusive-mobile": "assets/playbison/tag-playbison-exclusive.svg",
        "icon-inbox-empty": "assets/playbison/icon-inbox-empty.png"
    },
    "bison_win": {
        ...playbison_defaults,
        "name": "Bison Win",
        "originalDomain": "bison.win",
        "logo": "assets/bisonwin/logo-color.png",
        "logo-desktop": "assets/bisonwin/logo-color.png",
    },
    "bison_casino": {
        ...playbison_defaults,
        "name": "Bison Casino",
        "originalDomain": "bison.casino",
        "logo": "assets/bisoncasino/logo-color.svg",
        "logo-desktop": "assets/bisoncasino/logo-color.svg",
        // "logo": "assets/logo/2024/logo-xmas-desktop.svg",
        // "logo-desktop": "assets/logo/2024/logo-xmas-desktop.svg",
    },
    "bison_india": {
        ...playbison_defaults,
        "name": "Bison Casino",
        "logo": "assets/bisoncasino/logo-color.svg",
        "logo-desktop": "assets/bisoncasino/logo-color.svg",
        "jackpot-avatar": "assets/playbison/icon-indian-avatar.gif",

    },
    "fireball": {
        ...fireball_defaults,
        "freshdeskWebChat": FIREBALL_FRESHDESK,
        "activePromotionDisplay": "activePromotionDisplayFireball",
        "activeGamificationDisplay": "activeGamificationDisplayFireball",
        "activePendingRewardsDisplay": "activePendingRewardsDisplay",
        "bonusFirstDepositWithDate": "bonusFirstDepositWithDate",
        "depositTeaserDisplay": "depositTeaserDisplayFireball",
        "activePromotionDisplayBooster": "activePromotionDisplayBoosterFireball"
    },
    "meteoro": {
        ...fireball_defaults,
        "freshdeskWebChat": METEORO_FRESHDESK,
        "name": "Meteoro casino",
        "title-substitute": "Meteoro Casino",
        "originalDomain": "meteoro.casino",
        "logo": "assets/fireball/logo-meteoro.svg",
        "logo-desktop": "assets/fireball/logo-meteoro.svg",
        "activePromotionDisplay": "activePromotionDisplayMeteoro",
        "activeGamificationDisplay": "activeGamificationDisplayMeteoro",
        "activePendingRewardsDisplay": "activePendingRewardsDisplayMeteoro",
        "bonusFirstDepositWithDate": "bonusFirstDepositWithDateMeteoro",
        "depositTeaserDisplay": "depositTeaserDisplayMeteoro",
        "activePromotionDisplayBooster": "activePromotionDisplayBoosterMeteoro",
        "icon-register": "assets/meteoro/icon-registration.jpg"
    }
}   